import { Component, OnInit } from '@angular/core';
import { Destroyable } from 'app/core/util/destroyable';
import { delay, of } from 'rxjs';
import { appSettings } from '../../../appSettings';
import { ConfigMW } from '../../../core/interfaces/config.interface';
import { util } from '../../../core/util/util';

declare var config: ConfigMW;

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent extends Destroyable implements OnInit {
  private _blockRedirect: boolean;

  constructor() {
    super();
  }

  ngOnInit(): void {
    of(null)
      .pipe(delay(appSettings.ARTIFICIAL_DELAY_MS), this.takeUntilDestroyed())
      .subscribe(() => {
        util.deleteCookie('launchpad');

        this.doRedirect();
      });
  }

  async toggleBlockRedirect(): Promise<void> {
    this._blockRedirect = !this._blockRedirect;

    if (!this._blockRedirect) {
      await this.doRedirect();
    }
  }

  async doRedirect(): Promise<void> {
    if (this._blockRedirect) {
      return;
    }
    let { launchpadUrl } = config;
    if (document.location.href.startsWith('http://localhost')) {
      launchpadUrl = 'http://localhost:4300';
    }

    // Redirect to the launchpad logout
    window.location.href = `${launchpadUrl}/#/logout`;
  }
}
